type Props = {
  fill: string;
  height: string;
  width: string;
};

const TickIcon = ({ height, width, fill }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3332 14.781V16.0077C29.3315 18.8829 28.4005 21.6806 26.679 23.9834C24.9574 26.2863 22.5376 27.971 19.7803 28.7862C17.0231 29.6014 14.0762 29.5035 11.3791 28.5071C8.68208 27.5107 6.37938 25.6691 4.81445 23.2571C3.24953 20.845 2.50623 17.9917 2.69541 15.1227C2.88459 12.2537 3.99611 9.52275 5.86421 7.33708C7.73231 5.15141 10.2569 3.62816 13.0614 2.99451C15.866 2.36087 18.8002 2.65077 21.4265 3.82099"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 6.66669L16 20L12 16.004"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TickIcon;
